import { useUserRole } from './useUserRole';

export const useRoleBasedNavigation = () => {
  const { role, loading, isAdmin, isPractitioner, hasGroupSessionAccess } = useUserRole();

  /**
   * Get the primary dashboard route for the current user based on their role
   */
  const getPrimaryDashboard = (): string => {
    if (loading) return '/app';
    
    if (isAdmin) return '/admin';
    if (isPractitioner) return '/practitioner';
    return '/app';
  };

  /**
   * Get suggested alternative route when access is denied
   */
  const getSuggestedRoute = (attemptedRoute: string): { route: string; label: string } | null => {
    if (loading) return null;

    // If trying to access admin but only has practitioner access
    if (attemptedRoute === '/admin' && !isAdmin && isPractitioner) {
      return { route: '/practitioner', label: 'Practitioner Dashboard' };
    }

    // If trying to access practitioner but doesn't have group session access
    if (attemptedRoute.startsWith('/practitioner') && !hasGroupSessionAccess) {
      return { route: '/app', label: 'Main Dashboard' };
    }

    return null;
  };

  /**
   * Get all available dashboard routes for the user
   */
  const getAvailableDashboards = (): Array<{ route: string; label: string; icon?: string }> => {
    const dashboards = [];
    
    dashboards.push({ route: '/app', label: 'Main Dashboard', icon: 'Home' });
    
    if (hasGroupSessionAccess) {
      dashboards.push({ route: '/practitioner', label: 'Practitioner Dashboard', icon: 'Users' });
    }
    
    if (isAdmin) {
      dashboards.push({ route: '/admin', label: 'Admin Dashboard', icon: 'Shield' });
    }

    return dashboards;
  };

  return {
    loading,
    role,
    isAdmin,
    isPractitioner,
    hasGroupSessionAccess,
    getPrimaryDashboard,
    getSuggestedRoute,
    getAvailableDashboards
  };
};